import { render, staticRenderFns } from "./CardAcceptanceSettings.vue?vue&type=template&id=168ec6f7&"
import script from "./CardAcceptanceSettings.vue?vue&type=script&lang=ts&"
export * from "./CardAcceptanceSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports